import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, VStack, HStack, Icon, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const MotionBox = motion(Box);

const ExperiencedProjects = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500" maxW="2xl">
              {data.description}
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8} w="full">
            {data.projects.map((project, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Box
                  p={8}
                  bg="brand.50"
                  borderRadius="2xl"
                  h="full"
                  _hover={{
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(16,185,129,0.2)',
                    bg: 'white',
                  }}
                  transition="all 0.3s"
                >
                  <VStack align="start" spacing={4}>
                    <HStack justify="space-between" w="full">
                      <Icon as={project.icon} boxSize={10} color="accent.green" />
                      <Badge
                        px={3}
                        py={1}
                        bg="accent.gold"
                        color="brand.800"
                        fontSize="xs"
                        fontWeight="700"
                        borderRadius="full"
                      >
                        {project.badge}
                      </Badge>
                    </HStack>
                    
                    <Heading size="md" color="brand.700">
                      {project.title}
                    </Heading>
                    
                    <Text color="brand.500" fontSize="sm">
                      {project.desc}
                    </Text>

                    <HStack spacing={4} pt={2}>
                      <HStack spacing={2} color="brand.600" fontSize="sm" cursor="pointer" _hover={{ color: 'accent.green' }}>
                        <Icon as={FaGithub} />
                        <Text fontWeight="600">GitHub</Text>
                      </HStack>
                      <HStack spacing={2} color="brand.600" fontSize="sm" cursor="pointer" _hover={{ color: 'accent.green' }}>
                        <Icon as={FaExternalLinkAlt} />
                        <Text fontWeight="600">Demo</Text>
                      </HStack>
                    </HStack>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ExperiencedProjects;